import Component from '@glimmer/component';
import { t } from 'ember-intl';
import WLoginDialog from 'login/components/w-login-dialog';
import type { ApplicationModel } from 'login/routes/application';

export default class Disconnected extends Component<{ Args: { model: ApplicationModel } }> {
  <template>
    <WLoginDialog
      @pageTitle={{t 'login.title.disconnected'}}
      @dialogTitle={{@model.logonParams.serviceName}}
      @version={{@model.version}}
    >
      <div class='centered-line'>
        {{t 'login.disconnected'}}
      </div>
    </WLoginDialog>
  </template>
}
